export default {
  media: {
    select: {
      video: "Sélectionner une vidéo (MP4, MOV, WebM)",
      audio: "Sélectionner un audio (MP3, M4A, AAC, WAV, OGG)",
    },
    noFile: {
      video: "Aucune vidéo",
      audio: "Aucun audio",
    },
    remove: "Retirer",
    validation: {
      badFormat: {
        video: "La vidéo doit être au format MP4, MOV ou WebM.",
        audio: "L'audio doit être au format MP3, M4A, AAC, WAV ou OGG.",
      },
      maxFileSize: {
        video: "La vidéo ne doit pas dépasser 500 Mo.",
        audio: "L'audio ne doit pas dépasser 100 Mo.",
      },
    },
  },
  image: {
    title: "Images",
    name: "Image",
    upload: "Importer",
    uploadSuccess: "Images importées avec succès",
    uploadError: "Erreur lors de l'import",
    drop: "Cliquez ou glissez-déposez une image",
    dropOrClick: "Cliquez ou glissez-déposez une nouvelle image",
    myImages: "Les images de la formation",
    sharedImage: "Les images partagées",
    noImage: "Aucune image n'a été importée",
    pickerImage: "Images",
    pickerUpload: "Importer",
    selectImage: "Sélectionner une image",
    noImageSelected: "Aucune image",
    currentImage: "Image actuelle",
    newImage: "Nouvelle image",
    remove: "Retirer",
    validation: {
      badFormat: "Le fichier doit être au format JPG, PNG ou SVG.",
      maxFileSize: "L'image ne doit pas dépasser 5Mo.",
      badImageSize:
        "L'image doit avoir une dimension de 500x500px ou 625x500px.",
      imageNotReadable: "Impossible de lire l'image.",
      tooSmallImage: "L'image est trop petite.",
      conversionError: "Erreur lors de la conversion de l'image.",
      loadError: "Erreur lors du chargement de l'image.",
    },
  },
  topicCategory: {
    title: "Catégories",
    field: {
      name: "Nom",
      rank: "#",
    },
  },
  trainingVersion: {
    title: "Versions de formation",
    field: {
      rank: "#",
      title: "Titre",
      description: "Description",
      isAvailable: "Disponible",
      topicIds: "Thèmes",
      topicIdsPlaceholder:
        "Recherchez et sélectionnez les thèmes inclus dans cette version.",
      relatedTopicIds: "Thèmes liés",
      relatedTopicIdsPlaceholder:
        "Recherchez et sélectionnez les thèmes associés.",
    },
  },
  testimony: {
    title: "Témoignages",
    status: {
      draft: "Brouillon",
      available: "Disponible",
      unavailable: "Indisponible",
    },
    field: {
      title: "Titre",
      subtitle: "Sous-titre",
      description: "Description",
      status: "Statut",
      image: "Image",
      videoLink: "Lien vidéo",
      text: "Texte",
      tags: "Tags",
      keywords: "Mots-clés de recherche",
      comments: "Commentaires",
      rank: "#",
    },
  },
  topic: {
    title: "Thèmes",
    new: "Nouveau thème",
    status: {
      draft: "Brouillon",
      available: "Disponible",
      unavailable: "Indisponible",
    },
    level: {
      all: "Tous",
      beginner: "Débutant",
      intermediate: "Intermédiaire",
      advanced: "Avancé",
    },
    help:
      "Les infos sont affichées dans l'application de la manière suivante :",
    field: {
      title: "Titre",
      description: "Description",
      image: "Image",
      level: "Niveau",
      status: "Statut",
      tags: "Tags",
      rank: "#",
      category: "Catégorie",
      keywords: "Mots-clés de recherche",
      introduction: "Introduction",
      synthesis: "Synthèse",
      conclusion: "Conclusion",
      goals: "Objectifs",
      relatedTopics: "Thèmes liés",
      relatedTopicsPlaceholder:
        "Recherchez et cochez les thèmes à associer à celui-ci.",
      comments: "Commentaires",
      categoryPlaceholder: "Sélectionnez une catégorie",
      titlePlaceholder: "Les Fondements du Mariage",
      descriptionPlaceholder: "Comprendre les bases d’un mariage solide",
      levelPlaceholder: "Tous",
      statusPlaceholder: "Disponible",
      tagsPlaceholder: "Mariage, Famille, Relation",
      keywordsPlaceholder: "mariage, famille, relation",
      introductionPlaceholder: "Introduction",
      synthesisPlaceholder: "Synthèse",
      conclusionPlaceholder: "Conclusion",
      goalsPlaceholder: "Objectifs",
      commentsPlaceholder: "",
    },
  },
  topicPart: {
    title: "Parties",
    new: "Nouvelle partie",
    addSynthesisPart: "Partie synthèse",
    synthesisPartAlreadyExists:
      "Une seule partie de synthèse est autorisée par thème",
    defaultSynthesis: {
      title: "Soirée couple",
      description:
        "Nous prenons un temps à deux pour échanger et faire le point ensemble sur le thème abordé",
      text: "Je peux maintenant prendre quelques instants pour relire mes réponses, sélectionner celles que je souhaite partager, puis répondre aux questions de synthèse",
      question1: "Qu'est-ce que j'ai envie de partager ?",
      question2: "Quel est pour moi le point le plus important de ce thème ?",
    },
    field: {
      answerTogether: "Réponses ensemble",
      isSynthesisPart: "Partie de synthèse",
      title: "Titre",
      description: "Description",
      image: "Image",
      duration: "Durée (min)",
      videoLink: "Lien vidéo",
      videoFile: "Fichier vidéo",
      audioFile: "Fichier audio",
      contentText: "Texte",
      additionalText: "Texte Additionnel (Voir plus)",
      comments: "Commentaires",
      rank: "#",
      titlePlaceholder: "Les Bases du Mariage Chrétien",
      descriptionPlaceholder: "Présentation des piliers fondamentaux",
      durationPlaceholder: "30",
      videoLinkPlaceholder: "https://www.youtube.com/watch?v=dQw4w9WgXcQ",
      contentTextPlaceholder: "Entrez le texte principal",
      additionalTextPlaceholder: "Entrez le texte additionnel",
      commentsPlaceholder: "",
    },
    validation: {
      videoSourceConflict:
        "Choisissez soit un lien vidéo, soit un fichier vidéo, pas les deux.",
    },
  },
  topicPartQuestion: {
    title: "Questions",
    answerType: {
      text: "Texte",
      multipleChoice: "Choix multiple",
      singleChoice: "Choice unique",
      yesNo: "Oui - Non",
      yesNoUnknown: "Oui - Non - ne sais pas",
    },
    field: {
      text: "Question",
      textPlaceholder: "Quels sont les piliers d’un mariage chrétien ?",
      answerType: "Type de réponse",
      type: "Type",
      answers: "Reponses",
      rank: "#",
      comments: "Commentaires",
    },
  },
};
